import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-truck-line', text: 'Intervention rapide 24/48h' },
  { icon: 'ri-building-2-line', text: 'Techniciens salariés formés' },
  { icon: 'ri-time-line', text: 'Devis gratuit sans engagement' },
  { icon: 'ri-tools-line', text: 'Tout le matériel à bord' },
];

export default function TeamSection() {
  return (
    <section className="py-10 md:py-14 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
          <div className="flex-1 w-full">
            <p className="text-xs md:text-sm text-brand-accent font-medium mb-2 uppercase tracking-wider">
              Votre réparateur local
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3 font-heading leading-tight">
              Une équipe dédiée à la réparation de vos menuiseries
            </h2>
            <p className="text-sm md:text-base text-brand-text/60 mb-6 leading-relaxed">
              Nos techniciens salariés interviennent dans tout le 15ᵉ avec tout le matériel nécessaire. Zéro sous-traitance, un seul interlocuteur, diagnostic précis et devis fixe.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((f, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 p-3 bg-white rounded-xl border border-brand-mint/60 shadow-sm"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-brand-accent/10 flex-shrink-0">
                    <i className={`${f.icon} text-brand-accent text-sm`}></i>
                  </div>
                  <span className="text-sm font-medium text-brand-dark">{f.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full md:w-[48%] h-64 sm:h-72 md:h-80 rounded-2xl overflow-hidden flex-shrink-0 shadow-lg">
            <img
              alt="Équipe DF PRO intervenue sur Paris 15ᵉ — réparation fenêtres et menuiseries"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              src="/images/dfpro-team-new.webp"
            />
          </div>
        </div>
      </div>
    </section>
  );
}